import {
  Component,
  Inject,
  Injector,
  InjectionToken,
  ComponentRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  CdkPortalOutletAttachedRef,
  ComponentPortal,
  PortalInjector,
} from '@angular/cdk/portal';

import { MgDialogData, MgModalContent } from '../dialog.interface';
import { BehaviorSubject, Observable } from 'rxjs';

// prettier-ignore
export const DIALOG_CONTENT_PARAMS: InjectionToken<any> = new InjectionToken<any>('dialogContentParams');

@Component({
    selector: 'app-mg-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent {
  public contentInjector: PortalInjector;
  public contentPortal: ComponentPortal<MgModalContent>;
  // TODO -- need to fix MgModalContent type
  private readonly _componentInstance$: BehaviorSubject<any>;
  public readonly componentInstance$: Observable<any>;

  public get componentInstance() {
    return this._componentInstance$.getValue();
  }

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MgDialogData,
    private injector: Injector
  ) {
    this._componentInstance$ = new BehaviorSubject<any>(undefined);
    this.componentInstance$ = this._componentInstance$.asObservable();
    const injectTokens = new WeakMap();
    injectTokens.set(DIALOG_CONTENT_PARAMS, data.params);
    this.contentInjector = new PortalInjector(this.injector, injectTokens);
    this.contentPortal = new ComponentPortal<any>(
      // TODO -- need to fix MgModalContent type
      this.data.content as any,
      undefined,
      this.contentInjector
    );
    this.dialogRef.disableClose = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public handleContentAttached(ref: CdkPortalOutletAttachedRef) {
    this._componentInstance$.next((ref as ComponentRef<any>).instance);
  }
}
